<app-generic-button-card
  [title]="project().name"
  [cardLevel]="CardLevel.Second"
  [testId]="'project-card-' + project().id"
  [actionLabel]="isActiveOrTenantAdmin ? t('goToProject') : isRejected ? t('status.rejected') : ''"
  [actionStyleClass]="
    isActiveOrTenantAdmin
      ? 'p-button-secondary w-full text-sm! tracking-wider uppercase overflow-hidden'
      : isRejected
        ? 'p-button-secondary w-full text-sm! tracking-wider uppercase bg-gray-400! border-gray-400! cursor-not-allowed overflow-hidden'
        : 'w-full overflow-hidden'
  "
  [actionIcon]="isActiveOrTenantAdmin ? 'pi pi-arrow-right' : ''"
  [actionIconPos]="'right'"
  [onAction]="isActiveOrTenantAdmin ? onGoToProject.bind(this) : undefined"
  [actionDisabled]="isRejected"
  *transloco="let t; prefix: 'project'"
>
  <ng-container card-header>
    <div
      class="flex items-center justify-between h-12"
      [attr.data-testid]="'project-card-menu-' + project().id"
    >
      @if (project().archivedAt) {
        <span class="font-bold text-primary!" data-testid="project-status">
          {{ t('status.archived') }}
        </span>
        @if (hasVisibleMenuItems) {
          <p-menu #archivedMenu [model]="menuItems" [popup]="true"></p-menu>
          <p-button
            styleClass="p-button-text text-white!"
            icon="pi pi-ellipsis-v"
            (click)="archivedMenu.toggle($event)"
            (keydown.enter)="archivedMenu.toggle($event)"
            [attr.data-testid]="'archived-menu-button-' + project().id"
          ></p-button>
        }
      } @else {
        <div *appProjectRoleAccess="projectManagementConfig()">
          <p-menu #menu [model]="menuItems" [popup]="true"></p-menu>
          <p-button
            styleClass="p-button-text text-white!"
            icon="pi pi-ellipsis-v"
            (click)="menu.toggle($event)"
            (keydown.enter)="menu.toggle($event)"
            [attr.data-testid]="'edit-button-' + project().id"
          ></p-button>
        </div>
      }
    </div>
  </ng-container>

  <div card-body class="flex flex-col h-full text-sm text-gray-300 mt-3">
    <div>
      @if (project().createdAt) {
        <div class="flex justify-between" data-testid="project-start-date">
          <span>{{ t('startDate') }}:</span>
          <span>{{ project().createdAt | appDate }}</span>
        </div>
      }
      @if (project().endDate) {
        <div class="flex justify-between mt-1" data-testid="project-end-date">
          <span>{{ t('estimatedEnd') }}:</span>
          <span>{{ project().endDate | appDate }}</span>
        </div>
      }
      <div class="flex justify-between mt-1" data-testid="project-manager">
        <span>{{ t('projectManager') }}:</span>
        <span class="font-bold text-right">{{ project().projectManager ?? '-' }}</span>
      </div>
    </div>

    <div class="flex-1"></div>

    <div class="mt-4 mb-1">
      <app-progress-bar
        [completed]="chaptersCompleted()"
        [total]="totalChapters()"
        [label]="t('stepsCompleted')"
        testIdInfo="project-progress-info"
        testIdBar="project-progress-bar"
        *transloco="let t; prefix: 'project'"
      ></app-progress-bar>
    </div>
  </div>

  <ng-container card-footer></ng-container>

  @if (isInvited) {
    <div card-footer class="flex flex-col gap-2 items-stretch">
      <p-button
        (onClick)="confirmAccept()"
        [label]="t('invitation.accept')"
        icon="pi pi-check"
        styleClass="flex-1 text-sm! tracking-wider uppercase w-full"
        [attr.data-testid]="'accept-invitation-' + project().id"
      ></p-button>
      <p-button
        (onClick)="confirmReject()"
        [label]="t('invitation.reject')"
        icon="pi pi-times"
        styleClass="flex-1 text-sm! tracking-wider uppercase w-full"
        severity="danger"
        [attr.data-testid]="'reject-invitation-' + project().id"
      ></p-button>
    </div>
  }
</app-generic-button-card>
